import React from 'react';
import PropTypes from 'prop-types';

import { BarContainer, Bar } from './styles';

const ProgressBar = ({ progress }) => (
  <BarContainer>
    <Bar progress={progress} />
  </BarContainer>
);

ProgressBar.propTypes = {
  progress: PropTypes.number,
};
ProgressBar.defaultProps = {
  progress: 0,
};

export default ProgressBar;
